import { Fragment, useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import { editarBreadcrumb } from '../../actions/breadcrumb';
import { buscarClientes, filtarClientes } from '../../actions/clientes';

import FiltrosClientes from './FiltrosClientes';
import EliminarCliente from './EliminarCliente';

const Clientes = () => {

    let rutasBread = [
        {
            activo: true,
            nombre: 'Clientes',
            path: '/clientes'
        }
    ];

    const dispatch =  useDispatch();

    const { usuario } = useSelector(state => state.auth);
    const { listado } = useSelector(state => state.clientes);

    const [clientes, setClientes] = useState([]);

    const [clienteEliminar, setClienteEliminar] = useState(null);

    const paginationOptions = { rowsPerPageText: 'Filas por página', rangeSeparatorText: 'de' };

    const columns = [
        {
            name: 'Nombre',
            sortable: true, 
            selector: row => row.nombre || '-'
        },
        {
            name: 'Apellido Paterno',
            sortable: true, 
            selector: row => row.apellido_paterno || '-'
        },
        {
            name: 'Apellido Materno',
            sortable: true, 
            selector: row => row.apellido_materno || '-'
        },
        {
            name: 'Celular',
            sortable: true, 
            selector: row => row.celular || '-'
        },
        {
            name: 'Email',
            sortable: true, 
            selector: row => row.email || '-'
        },
        {
            name: '',
            cell: row => {
                return(
                    <div className="text-right w-100">
                        {
                            usuario?.permisos?.clientes?.eliminar &&
                                <button type="button" className="btn btn-sm btn-link px-2 float-end" onClick={() => handleEliminarCliente(row)}><i className="fas fa-trash text-danger"></i></button>
                        }
                        {
                            usuario?.permisos?.clientes?.editar &&
                                <Link className="btn btn-sm btn-link px-2 float-end" to={`/clientes/editar/${row._id}`}><i className="fas fa-edit text-warning"></i></Link>
                        }
                        {
                            usuario?.permisos?.clientes?.detalles &&
                                <Link className="btn btn-sm btn-link px-2 float-end" to={`/clientes/detalles/${row._id}`}><i className="fas fa-circle-info text-info"></i></Link>
                        }
                    </div>
                )
            }
        }
    ];

    /* Filtros de busqueda */
    const handleFiltrosBusqueda = () => {
        dispatch(filtarClientes(true));
    }

    /* Eliminar cliente */
    const handleEliminarCliente = (cliente) => {
        setClienteEliminar(cliente);
    }

    useEffect(() => {
        dispatch(buscarClientes({
            nombre: null,
            apellido_paterno: null,
            apellido_materno: null,
            celular: null,
            email: null
        }));
    }, []);

    useEffect(() => {
        setClientes(listado);
    }, [listado]);

    useEffect(() => {
        dispatch(editarBreadcrumb(rutasBread));
    }, [rutasBread]);

    return (
        <Fragment>

            <FiltrosClientes />
            <EliminarCliente cliente={clienteEliminar} reestablecerCliente={handleEliminarCliente} />

            <div className="row">
                <div className="col-md-10 offset-md-1 pb-4">
                    <h3 className="my-5">Clientes</h3>        

                    <div className="d-flex justify-content-end">
                        <button type="button" className="btn btn-primary me-2" onClick={() => handleFiltrosBusqueda()}>Filtros de búsqueda</button>
                        {
                            usuario?.permisos?.clientes?.agregar &&
                                <Link to="/clientes/nuevo">
                                    <button className="btn btn-primary">Agregar cliente</button>
                                </Link>
                        }
                    </div>            

                    <div className="mt-2">
                        <DataTable 
                            columns={columns}
                            data={clientes}
                            pagination
                            paginationPerPage={20}
                            paginationRowsPerPageOptions={[5, 10, 20, 50]}
                            paginationComponentOptions={paginationOptions}
                            highlightOnHover={true}
                        />
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default Clientes;